import { ClientesListSearchComponent } from './ClientesListSearchComponent'
import { ClientesListToolbar } from './ClientesListToolbar'

export const ClientesListHeader = () => {
  return (
    <div className='card-header border-0 pt-6'>
      <ClientesListSearchComponent actions={<ClientesListToolbar />} />
    </div>
  )
}
